import { VenueTab } from '@3ddv/ngx-sites-builder-lib';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MultivenueService {
  constructor() {}

  public setFirstVenueFromSite() {}
  public validateNewItem(venueTab: VenueTab) {
    if (venueTab.mapId && venueTab.venueId) {
      return true;
    }
    return false;
  }
}
